import { useQuery, useQueryClient } from '@tanstack/react-query'
import { findPlanAndRateOverrideRuleByMatch } from '../../../api/plan-and-rate-override-rules-api'
import type { PlanAndRateOverrideRuleResponseDto } from '../../../api/dto/plan-and-rate-override-rules.dto'

export const FIND_PLAN_AND_RATE_RULE_QUERY_KEY = 'findPlanAndRateRuleByMatch'

interface MatchParams {
  hiosPlanId: string
  year: number
  state: string
}

export function useFindPlanAndRateRuleByMatch(params: MatchParams | null) {
  const { data, isLoading, refetch } = useQuery({
    queryKey: [FIND_PLAN_AND_RATE_RULE_QUERY_KEY, params],
    queryFn: () => {
      if (!params) return Promise.reject(new Error('params required'))
      return findPlanAndRateOverrideRuleByMatch(params)
    },
    enabled: params !== null,
    staleTime: 0,
    gcTime: 0,
  })

  const rule: PlanAndRateOverrideRuleResponseDto | null = data ?? null

  return { rule, isLoading, refetch }
}

export function useInvalidateFindPlanAndRateRule() {
  const queryClient = useQueryClient()
  return () =>
    queryClient.invalidateQueries({
      queryKey: [FIND_PLAN_AND_RATE_RULE_QUERY_KEY],
    })
}
